// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form {
  border-radius: 5px;
  width: 80%;
  height: 100%;
  /* height: 600px; */
}

.form-body {
  text-align: left;
  width: 34.6vw;
  margin-left: 7.3vw;
}

.form-body > * {
  padding: 5px;
  display: flex;
}

.form__label {
  position: absolute;
  /* top: 10px; */
  font-family: "N27";
  font-style: italic;
  font-weight: 400;
  font-size: 1.4vh;
  /* line-height: 22px; */
  
  /* height: 100%; */
  margin-left: 30px;
}

.checkbox {
  transform: rotate(-45deg);
  min-height: 16px;
  min-width: 16px;
  height: 1.4vh;
  width: 1.4vh;
  margin: 1px;
}

.form__input {
  border: none;
  border-bottom: 0.5px solid black;
  width: 100%;
  height: 50px;
  background-color: transparent;
  font-family: "N27";
  font-style: italic;
  font-weight: 400;
  font-size: 20px;
  -webkit-appearance: none;
  -webkit-border-radius:0;
}


.form__input::placeholder {
  color: #b6b7b2;
}

.form__input:focus {
  outline: none;
}

.submit-btn {
  position: relative;
  width: 41.7vh;
  height: 11.5vh;

  font-family: "N27";
  /* font-style: italic; */
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  transform: skew(-20deg);
  background: #eff0eb;
  color: #151515;
  border: 0.5px solid #151515;
  cursor: pointer;
}



.discord{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.Discord-ID{
  width: 50%;

}

.discord-icon{
  border-radius: 8;
}

.submit-btn:hover {
  background: #000000;
  color: #ffffff;
}

footer {
  text-align: center;
}

.error {
  margin: 0;
  font-family: "N27";
  font-style: italic;
  font-weight: 400;
  font-size: 12px;
  color: transparent;
}

.form-footer {
  position: absolute;
  width: 100%;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  top: 84vh;
}

.linecon {
  position: absolute;
  width: 84vw;
  height: 0px;
  left: 8vw;
  /* top: 60px; */
  border: 0.5px solid #151515;
}

.mob {
  display: none;
}

/* .checkbox input[type="checkbox"]:checked{
  border: 2px solid #fff!important;
  border-radius: 0.3em!important;
  background: #50565a!important;
  box-shadow: 2px 1px 0 #50565a!important;
} */
/*///////////////////////////////////////////////////////////////*/
.newsletters{
    display: flex;
    align-content: center;   
    align-items: center;
    padding: 0px;
    margin-top: 10px;
    margin-left: 5px;
}

input[type="checkbox"] {
  /* Add if not using autoprefixer */
  appearance: none;
  /* For iOS < 15 to remove gradient background */
  background-color: #EFF0EB(255, 255, 255);
  /* Not removed via appearance */
  margin: 0;
  font: inherit;
  color: rgb(0, 0, 0);
  width: 20px;
  height: 20px;
  border: 2px solid rgb(0, 0, 0);
  border-radius: 0.15em;
  transform: translateY(-0.075em);
  transform: rotate(-45deg);
  display: grid;
  place-content: center;
}

input[type="checkbox"]::before {
  content: "";
  width: 10px;
  height: 10px;
}

input[type="checkbox"]:checked::before {
  background-color: #282828;
  transform: scale(1);
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

  .mob {
    display: block;
    /* width: 100%; */
    /* display: flex; */
    /* font-size: 7.5px !important; */
  }

  .form {
    border-radius: 5px;
    width: 90vw;
    margin: 0;
    padding: 0;
  }

  .form-body {
    display: flex;
    flex-direction: column;
    width: 90%;
    margin: 0;
  }

  .form__input {
    width: 100%;
    height: 30px;
    background-color: transparent;
    font-family: "N27";
    font-style: italic;
    font-weight: 400;
    font-size: 12px;
  }

  .submit-btn {
    position: relative;
    width: 176px;
    height: 40px;
    font-size: 12px;
  }

  .form__label {
    position: relative;
    margin-left: 15px;
    /* left: 17px;
    font-size: 10px; */
  }

  .discord{
    width: 90%;
  }



  .linecon {
  }

  .sr {
  }

  .sl {
  }

  .error {
    font-size: 10px;
  }

  .footer {
    top: unset;
    position: unset;
    margin-top: 25px;
    /* position: relative;
    top: 15vh;
    left: -4vh; */
  }

  .socials h2 {
    margin-top: 5px !important;
    font-size: 7.5px !important;
    margin-top: 20px;
  }

}
`, "",{"version":3,"sources":["webpack://./src/Fom/components/RegistrationForm.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;;EAEvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,uBAAuB;AACzB;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;;EAEd,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,eAAe;AACjB;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;;AAEZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;GAKG;AACH,kEAAkE;AAClE;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;EACE,kCAAkC;EAElC,gBAAgB;EAChB,+CAA+C;EAC/C,wCAAwC;EACxC,+BAA+B;EAC/B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,qBAAqB;EACrB,+BAA+B;EAC/B,yBAAyB;EACzB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,iCAAiC;EACnC;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB;sBACkB;EACpB;;EAEA;IACE,UAAU;EACZ;;;;EAIA;EACA;;EAEA;EACA;;EAEA;EACA;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB;;iBAEa;EACf;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,gBAAgB;EAClB;;AAEF","sourcesContent":[".form {\n  border-radius: 5px;\n  width: 80%;\n  height: 100%;\n  /* height: 600px; */\n}\n\n.form-body {\n  text-align: left;\n  width: 34.6vw;\n  margin-left: 7.3vw;\n}\n\n.form-body > * {\n  padding: 5px;\n  display: flex;\n}\n\n.form__label {\n  position: absolute;\n  /* top: 10px; */\n  font-family: \"N27\";\n  font-style: italic;\n  font-weight: 400;\n  font-size: 1.4vh;\n  /* line-height: 22px; */\n  \n  /* height: 100%; */\n  margin-left: 30px;\n}\n\n.checkbox {\n  transform: rotate(-45deg);\n  min-height: 16px;\n  min-width: 16px;\n  height: 1.4vh;\n  width: 1.4vh;\n  margin: 1px;\n}\n\n.form__input {\n  border: none;\n  border-bottom: 0.5px solid black;\n  width: 100%;\n  height: 50px;\n  background-color: transparent;\n  font-family: \"N27\";\n  font-style: italic;\n  font-weight: 400;\n  font-size: 20px;\n  -webkit-appearance: none;\n  -webkit-border-radius:0;\n}\n\n\n.form__input::placeholder {\n  color: #b6b7b2;\n}\n\n.form__input:focus {\n  outline: none;\n}\n\n.submit-btn {\n  position: relative;\n  width: 41.7vh;\n  height: 11.5vh;\n\n  font-family: \"N27\";\n  /* font-style: italic; */\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 29px;\n  transform: skew(-20deg);\n  background: #eff0eb;\n  color: #151515;\n  border: 0.5px solid #151515;\n  cursor: pointer;\n}\n\n\n\n.discord{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.Discord-ID{\n  width: 50%;\n\n}\n\n.discord-icon{\n  border-radius: 8;\n}\n\n.submit-btn:hover {\n  background: #000000;\n  color: #ffffff;\n}\n\nfooter {\n  text-align: center;\n}\n\n.error {\n  margin: 0;\n  font-family: \"N27\";\n  font-style: italic;\n  font-weight: 400;\n  font-size: 12px;\n  color: transparent;\n}\n\n.form-footer {\n  position: absolute;\n  width: 100%;\n  left: 0px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: auto;\n  top: 84vh;\n}\n\n.linecon {\n  position: absolute;\n  width: 84vw;\n  height: 0px;\n  left: 8vw;\n  /* top: 60px; */\n  border: 0.5px solid #151515;\n}\n\n.mob {\n  display: none;\n}\n\n/* .checkbox input[type=\"checkbox\"]:checked{\n  border: 2px solid #fff!important;\n  border-radius: 0.3em!important;\n  background: #50565a!important;\n  box-shadow: 2px 1px 0 #50565a!important;\n} */\n/*///////////////////////////////////////////////////////////////*/\n.newsletters{\n    display: flex;\n    align-content: center;   \n    align-items: center;\n    padding: 0px;\n    margin-top: 10px;\n    margin-left: 5px;\n}\n\ninput[type=\"checkbox\"] {\n  /* Add if not using autoprefixer */\n  -webkit-appearance: none;\n  appearance: none;\n  /* For iOS < 15 to remove gradient background */\n  background-color: #EFF0EB(255, 255, 255);\n  /* Not removed via appearance */\n  margin: 0;\n  font: inherit;\n  color: rgb(0, 0, 0);\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgb(0, 0, 0);\n  border-radius: 0.15em;\n  transform: translateY(-0.075em);\n  transform: rotate(-45deg);\n  display: grid;\n  place-content: center;\n}\n\ninput[type=\"checkbox\"]::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n}\n\ninput[type=\"checkbox\"]:checked::before {\n  background-color: #282828;\n  transform: scale(1);\n}\n\n@media only screen and (max-width: 600px) {\n  .desktop {\n    display: none;\n  }\n\n  .mob {\n    display: block;\n    /* width: 100%; */\n    /* display: flex; */\n    /* font-size: 7.5px !important; */\n  }\n\n  .form {\n    border-radius: 5px;\n    width: 90vw;\n    margin: 0;\n    padding: 0;\n  }\n\n  .form-body {\n    display: flex;\n    flex-direction: column;\n    width: 90%;\n    margin: 0;\n  }\n\n  .form__input {\n    width: 100%;\n    height: 30px;\n    background-color: transparent;\n    font-family: \"N27\";\n    font-style: italic;\n    font-weight: 400;\n    font-size: 12px;\n  }\n\n  .submit-btn {\n    position: relative;\n    width: 176px;\n    height: 40px;\n    font-size: 12px;\n  }\n\n  .form__label {\n    position: relative;\n    margin-left: 15px;\n    /* left: 17px;\n    font-size: 10px; */\n  }\n\n  .discord{\n    width: 90%;\n  }\n\n\n\n  .linecon {\n  }\n\n  .sr {\n  }\n\n  .sl {\n  }\n\n  .error {\n    font-size: 10px;\n  }\n\n  .footer {\n    top: unset;\n    position: unset;\n    margin-top: 25px;\n    /* position: relative;\n    top: 15vh;\n    left: -4vh; */\n  }\n\n  .socials h2 {\n    margin-top: 5px !important;\n    font-size: 7.5px !important;\n    margin-top: 20px;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
